import { useMemo } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { IconBadge } from "@/DesignSystem";
import { AIScribeLinkedUserModel } from "../Models/AIScribeLinkedUserModel";

import styles from "./AIScribe.module.scss";

interface IAIScribeUserLinkStatusProps {
    user: AIScribeLinkedUserModel;
    showLink: boolean;
    onLinkClicked: () => void;
    onUnlinkClicked: () => void;
}

function AIScribeUserLinkStatus(props: Readonly<IAIScribeUserLinkStatusProps>): JSX.Element {
    const { getText } = useTranslation();
    const { user } = props;

    const iconStatus = useMemo(() => {
        if (!user)
            return "error";

        if (user.hasSubscription())
            return "success";

        return "warning";
    }, [user]);

    return (
        <div className={styles.linkStatusContainer + " row"} id="ai-scribe-user" data-cy="ai-scribe-user">
            <div className="hidden-sm hidden-xs col-md-2 col-lg-2 text-right">
                <label className="form-label bold">{cacheStore.GetString("AIScribe_CoeurWay")}</label>
            </div>
            <div className={`col-sm-6 col-md-4 col-lg-4 ${styles.message}`}>
                <span className={styles.icon} id="ai-scribe-user-status">
                    <IconBadge
                        size="sm"
                        variant={iconStatus}
                        dataCy="ai-scribe-user-status"
                    />
                </span>
                <div className={`${user ? "" : styles.errorMessage} ${styles.email}`} id="ai-scribe-user-message" data-cy="ai-scribe-user-message">
                    {user ? user.getEmail() : getText("AIScribe_NotLinked")}
                </div>
            </div>
            <div className="col-sm-4 col-md-6 col-lg-6">
                {props.showLink && user && (
                    <>
                        <button className={styles.linkButton} id="ai-scribe-user-anchor" data-cy="ai-scribe-user-anchor" onClick={() => props.onLinkClicked?.()} tabIndex={0}>
                            {getText("AIScribe_Modify")}
                        </button>
                        <span> | </span>
                        <button className={styles.linkButton} id="ai-scribe-user-anchor-unlink" data-cy="ai-scribe-user-anchor-unlink" onClick={() => props.onUnlinkClicked?.()} tabIndex={0}>
                            {getText("AIScribe_Unlink")}
                        </button>
                    </>
                )}
                {props.showLink && !user && (
                    <button className={styles.linkButton} id="ai-scribe-user-anchor-link" data-cy="ai-scribe-user-anchor-link" onClick={() => props.onLinkClicked?.()} tabIndex={0}>
                        {getText("AIScribe_Link")}
                    </button>
                )}
            </div>
        </div>
    );
}

export { AIScribeUserLinkStatus };
